import { render, staticRenderFns } from "./SettingsGroupModal.vue?vue&type=template&id=cca41de2&"
import script from "./SettingsGroupModal.vue?vue&type=script&lang=js&"
export * from "./SettingsGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports